<template>
  <div class="ion-margin-top report-component">
    <ion-item
      button
      :disabled="disabled"
      @click.stop="onItemClick"
      :class="{ 'item-has-value': !!date }"
    >
      <ion-label v-if="placeholders && placeholders[0]" position="floating">
        {{ placeholders[0] }}
      </ion-label>
      <ion-label v-else position="floating">HH:MM</ion-label>

      <ion-input
        :disabled="disabled"
        :value="formatForDisplay(date)"
        readonly
        tabindex="-1"
        class="no-pointer-events"
      ></ion-input>
    </ion-item>
  </div>
</template>

<script>
import { IonItem, IonInput, IonLabel } from '@ionic/vue';
import { mixinReportComponentsCommon } from '@/components/driver/rentalCoupon/mixins/ReportComponentsCommon';

export default {
  name: 'Date',

  components: {
    IonItem,
    IonInput,
    IonLabel,
  },

  mixins: [mixinReportComponentsCommon],

  props: {
    title: String,
    placeholders: Array,
    date: String,
    selectedDay: String,
    disabled: Boolean,
  },

  emits: ['update:date'],
};
</script>
